import { createSelector } from '@reduxjs/toolkit'

import { TAppStore } from '~/src/Configurations/AppStore'

export const SLICE_NAME = 'appState'

const select = (state: TAppStore) => state[SLICE_NAME]

export const isNriLogin = createSelector(select, appState => appState.nriLogin)

export const getSubsequentLoginNativeDisplayEventsForImpressions =
  createSelector(
    select,
    appState => appState?.nativeDisplayEvents?.['subsequent_login']
  )

export const getSubsequentLoginNativeDisplayEvents = createSelector(
  select,
  appState => appState?.nativeDisplayEvents?.['subsequent_login']?.kv
)
